module.exports = __webpack_public_path__ + "img/1f631.81195a98.svg";